<nav class="bg-white border-b border-gray-200">
    <div class="px-2 sm:px-6 lg:px-8">
        <div class="relative flex h-16 items-center justify-between">
            <div class="absolute inset-y-0 left-0 flex items-center md:hidden">
                <p-button icon="pi pi-bars" [rounded]="true" [text]="true" severity="secondary"
                    (onClick)="sidebarVisible.set(!sidebarVisible())" />
            </div>
            <div class="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                <img (click)="goToHome()" class="h-8 w-auto cursor-pointer"
                    src="https://vgd7mt9hnrcbpwqu.public.blob.vercel-storage.com/logotype.webp"
                    alt="Academia Balance" />
            </div>
            <div class="absolute inset-y-0 right-0 flex items-center gap-5 pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0">
                <div *appHasAction="ACTIONS.VIEW_FILTER_SCHOOL_COURSES" class="relative">
                    <app-select-school-year (yearChanged)="onYearChanged($event)"></app-select-school-year>
                </div>
                <div *appHasAction="ACTIONS.VIEW_TASKS" class="relative">
                    <app-tasks-badge></app-tasks-badge>
                </div>
                <div class="relative">
                    <app-dropdown-notifications></app-dropdown-notifications>
                </div>

                <span class="w-px self-stretch my-2 bg-gray-200"></span>

                <!-- Profile dropdown -->
                <div class="relative">
                    <app-dropdown-profile></app-dropdown-profile>
                </div>
            </div>
        </div>
    </div>
</nav>

<p-drawer [(visible)]="sidebarVisible" position="left" styleClass="!p-0" [modal]="true">
    <ng-template pTemplate="header">
        <div class="flex justify-between items-center">
            <img (click)="goToHome()" class="h-8 w-auto cursor-pointer"
                src="https://vgd7mt9hnrcbpwqu.public.blob.vercel-storage.com/logotype.webp" alt="Academia Balance" />
        </div>
    </ng-template>
    <app-sidebar (onClickLink)="sidebarVisible.set(false)"></app-sidebar>
</p-drawer>